import { ReviewModel } from '@/modules/review/review-model';

const { fields } = ReviewModel;

export default [
  fields.id,

  fields.createdAt
];
